import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { format } from 'date-fns';

interface CommissionData {
  orderId: string;
  customerName: string;
  revenue: number;
  commissionAmount: number;
  date: string;
  isPaid?: boolean;
}

interface PartnerData {
  first_name: string;
  last_name: string;
  email: string;
  commission_rate?: number;
}

export const generateCommissionInvoice = (
  commissions: CommissionData[],
  partner: PartnerData,
  monthYear: string
) => {
  // Filter to only include paid commissions
  const paidCommissions = commissions.filter(commission => commission.isPaid !== false);
  
  if (paidCommissions.length === 0) {
    alert('No paid commissions available to generate invoice');
    return;
  }
  
  const doc = new jsPDF();
  
  // Header
  doc.setFontSize(20);
  doc.text('Commission Invoice', 20, 30);
  
  // Partner Details
  doc.setFontSize(12);
  doc.text(`Partner: ${partner.first_name} ${partner.last_name}`, 20, 50);
  doc.text(`Email: ${partner.email}`, 20, 60);
  doc.text(`Commission Rate: ${partner.commission_rate || 0}%`, 20, 70);
  doc.text(`Period: ${monthYear}`, 20, 80);
  doc.text(`Generated: ${format(new Date(), 'dd/MM/yyyy HH:mm')}`, 20, 90);
  doc.text(`Note: Only includes commissions from paid orders`, 20, 100);
  
  // Commission breakdown table (only paid orders)
  const tableData = paidCommissions.map(commission => [
    commission.orderId.slice(0, 8),
    commission.customerName,
    `£${commission.revenue.toFixed(2)}`,
    `£${commission.commissionAmount.toFixed(2)}`,
    format(new Date(commission.date), 'dd/MM/yyyy')
  ]);
  
  // Calculate totals (only for paid commissions)
  const totalRevenue = paidCommissions.reduce((sum, c) => sum + c.revenue, 0);
  const totalCommission = paidCommissions.reduce((sum, c) => sum + c.commissionAmount, 0);
  
  // Add summary row
  tableData.push([
    'TOTAL',
    `${paidCommissions.length} paid orders`,
    `£${totalRevenue.toFixed(2)}`,
    `£${totalCommission.toFixed(2)}`,
    ''
  ]);
  
  (doc as any).autoTable({
    head: [['Order ID', 'Customer', 'Revenue', 'Commission', 'Date']],
    body: tableData,
    startY: 115,
    styles: { fontSize: 10 },
    headStyles: { fillColor: [79, 70, 229] },
    footStyles: { fillColor: [79, 70, 229], textColor: 255, fontStyle: 'bold' }
  });
  
  // Save the PDF
  doc.save(`commission-invoice-${monthYear.replace(' ', '-')}-paid-only.pdf`);
};